// extracted by mini-css-extract-plugin
module.exports = {"box":"Page4_box__3GlyP","title":"Page4_title__1LCgF","subTitle":"Page4_subTitle__2LDvB","labelText":"Page4_labelText__3ywOe"};